import {
  createStyles,
  Grid,
  Container,
  Card,
  Center,
  Button,
  Footer,
} from '@mantine/core';
import { motion } from 'framer-motion';
import { useState } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import BreadCrumbCompo from '../components/breadcrumbs/breadcrumbs-component';
import CardArticleCompo from '../components/content/cardarticle-component';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
import { useEffect } from 'react';
import Breadcrumbs2Component from '../components/breadcrumbs/breadcrumbs2-component';
import { FooterCompo } from '../components';
import {
  articlesIsEmpty,
  articlesStore,
  fetchArticles,
} from '../store/reducers/articleSlice';
import { useDispatch, useSelector } from 'react-redux';

const useStyle = createStyles((theme) => ({
  gridContainer: {},
  cardPageWrapper: {
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      overflow: 'hidden',
    },
  },
  title: {
    marginTop: 24,
    marginBottom: 40,
    fontSize: 24,
    fontWeight: 700,
    color: '#4D4D4D',
  },
  button: {
    marginTop: 20,
    marginBottom: 20,
    padding: '20px 30px',
    fontSize: 16,
    fontWeight: 700,
    height: 'auto',
  },
}));

const articleState = [
  {
    id: 1,
    image: 'https://placeimg.com/400/314/nature',
    title: 'Title',
    article:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet turpis quis rutrum sagittis. Sed sit amet luctus elit. uisque at nibh nulla. Morbi non libero facilisis, convallis libero vel, ullamcorper massa. Phasellus feugiat, erat a bibendum fringilla, diam nulla laoreet lacus, eu dignissim justo nisi ac erat.',
  },
  {
    id: 2,
    image: 'https://placeimg.com/400/314/people',
    title: 'Title',
    article:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet turpis quis rutrum sagittis. Sed sit amet luctus elit. uisque at nibh nulla. Morbi non libero facilisis, convallis libero vel, ullamcorper massa. Phasellus feugiat, erat a bibendum fringilla, diam nulla laoreet lacus, eu dignissim justo nisi ac erat.',
  },
  {
    id: 3,
    image: 'https://placeimg.com/400/314/sepia',
    title: 'Title',
    article:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet turpis quis rutrum sagittis. Sed sit amet luctus elit. uisque at nibh nulla. Morbi non libero facilisis, convallis libero vel, ullamcorper massa. Phasellus feugiat, erat a bibendum fringilla, diam nulla laoreet lacus, eu dignissim justo nisi ac erat.',
  },
  {
    id: 4,
    image: 'https://placeimg.com/400/314/animals',
    title: 'Title',
    article:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet turpis quis rutrum sagittis. Sed sit amet luctus elit. uisque at nibh nulla. Morbi non libero facilisis, convallis libero vel, ullamcorper massa. Phasellus feugiat, erat a bibendum fringilla, diam nulla laoreet lacus, eu dignissim justo nisi ac erat.',
  },
  {
    id: 5,
    image: 'https://placeimg.com/400/314/tech',
    title: 'Title',
    article:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet turpis quis rutrum sagittis. Sed sit amet luctus elit. uisque at nibh nulla. Morbi non libero facilisis, convallis libero vel, ullamcorper massa. Phasellus feugiat, erat a bibendum fringilla, diam nulla laoreet lacus, eu dignissim justo nisi ac erat.',
  },
  {
    id: 6,
    image: 'https://placeimg.com/400/314/tech',
    title: 'Title',
    article:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquet turpis quis rutrum sagittis. Sed sit amet luctus elit. uisque at nibh nulla. Morbi non libero facilisis, convallis libero vel, ullamcorper massa. Phasellus feugiat, erat a bibendum fringilla, diam nulla laoreet lacus, eu dignissim justo nisi ac erat.',
  },
];

const ArticleContentPage = () => {
  const { classes } = useStyle();

  const articles = useSelector(articlesStore);
  const empty = useSelector(articlesIsEmpty);
  const dispatch = useDispatch();

  useEffect(() => {
    Aos.init({
      duration: 300,
      easing: 'ease-in-sine',
      offset: 200,
      delay: 100,
    });

    if (empty) {
      (async function fetch() {
        dispatch(await fetchArticles());
      })();
    }
  }, [empty, dispatch]);

  return (
    <motion.div
      className={classes.cardPageWrapper}
      initial={{ width: 0 }}
      animate={{ width: '100%' }}
      exit={{ x: window.innerWidth, transition: { duration: 0.3 } }}
    >
      <div className="container">
        <h1 className={classes.title}>Artikel</h1>
      </div>
      <div className="container">
        <div className="row">
          {articles &&
            articles.map((item, key) => {
              return (
                <div className="col-sm-12 col-md-6 col-lg-4" 
                    key={key}>
                  <CardArticleCompo
                    id={item.id}
                    image={item.cover_url}
                    title={item.title}
                    article={item.caption}
                    likes={item.likes}
                  />
                </div>
              );
            })}
        </div>
        <Center>
          <Button
            color="teal.9"
            radius="xl"
            className={classes.button}
            onClick={async () =>
              dispatch(await fetchArticles(
                articles[articles.length - 1].created_at.seconds,
                articles[articles.length - 1].id,
              ))
            }
          >
            Lainnya
          </Button>
        </Center>
      </div>
      {/* <Grid data-aos="fade-right" gutter={20} className={classes.gridContainer}>
        {article.map((item, key) => {
          return (
            <Grid.Col md={6} lg={3}>
              <CardArticleCompo
                key={key}
                image={item.image}
                title={item.title}
                article={item.article}
              />
            </Grid.Col>
          );
        })}
      </Grid> */}
      <JumboTron2 />
      <FooterCompo />
    </motion.div>
  );
};
export default ArticleContentPage;
